import React, { Component } from "react";
import {
  Col,
  Row,
  Container,
  Card,
  CardHeader,
  Input,
  Button,
  Modal,
} from "reactstrap";

import config from "../../config";
import RequestManager from "../../singletons/RequestManager";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import LoadingOverlay from "react-loading-overlay";
import Autocomplete from "react-autocomplete";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import {generateHeaders, generateHeaderswithBasicAuthToken, generateEpochTimestamp, generateSignature} from "../../utils/helper";
const CustomInput = React.forwardRef((props, ref) => {
  return (
    <input
      onClick={props.onClick}
      value={props.value}
      type="text"
      readOnly={true}
      ref={ref}
    />
  );
});

const filterData = (data = [], value) => {
  let filteredArr = data.filter((stock) => {
    // eslint-disable-next-line
    stock.node.sku.product.category.name + " - " + stock.node.referenceName;
    console.log(
      " stock.node.sku.product.category.name",
      stock.node.sku.product.category.name.toLowerCase()
    );
    return (
      !value ||
      stock.node.sku.product.category.name
        .toLowerCase()
        .includes(value.toLowerCase()) ||
      stock.node.referenceName.toLowerCase().includes(value.toLowerCase()) ||
      (stock.node.locallngName &&
        stock.node.locallngName.toLowerCase().includes(value.toLowerCase()))
    );
  });
  return filteredArr;
};

const filterDataY = (data = [], value) => {
  let filteredArr = data.filter((stock) => {
    // eslint-disable-next-line
    stock.node.sku.product.category.name + " - " + stock.node.referenceName;
    console.log(
      " stock.node.sku.product.category.name",
      stock.node.sku.product.category.name.toLowerCase()
    );
    return (
      !value ||
      stock.node.sku.product.category.name
        .toLowerCase()
        .includes(value.toLowerCase()) ||
      stock.node.referenceName.toLowerCase().includes(value.toLowerCase()) ||
      (stock.node.locallngName &&
        stock.node.locallngName.toLowerCase().includes(value.toLowerCase()))
    );
  });
  return filteredArr;
};
export default class Offers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorModalVisible: false,
      codeSelect: false,
      manualCode: "",
      filterValue: "",
      filterData: [],
      filterDataY: [],
      filterValueY: "",
      MRValue: "0",
      quantityAmount: "",
      purchaseAmount: "",
      percentage: "",
      fixedAmount: "",
      types: "0",
      usageLimits: "0",
      usageLimitNumber: "",
      stocks: [],
      startDate: moment().startOf("day"),
      endDate: moment().endOf("day"),
      selectedStore: null,
      storeInformation: null,
      spinnerLoading: false,
      selectedSkuX: "",
      selectedSkuY: "",
      YPercentage: "",
      storeMerchantLevel: "",
      offerName: "",
      offerDescription: "",
      errorMessage: "",
      usagePerCustomer: "",
      percentageMaxAmount: "",
      endDateSelect: false,
    };
  }

  componentDidMount() {
    this.setupInitialCondition();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.selectedStore !== null) {
      if (prevState.selectedStore === null) {
        //this.getInventory();
      } else if (this.state.selectedStore.id !== prevState.selectedStore.id) {
        //this.getInventory();
      }
    }
  }
  toggleErrorMessageModal = (text) => {
    this.setState({
      errorModalVisible: !this.state.errorModalVisible,
      errorMessage: text,
    });
  };
  setupInitialCondition = async () => {
    let loginMode = localStorage.getItem("loginMode");
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    if (loginMode === "store") {
      console.log(storeInformation.store);
      this.setState({
        selectedStore: storeInformation.store,
        storeInformation: storeInformation,
      });
    } else {
      let stores = await this.getStores(storeInformation.merchant.id);
      if (stores) {
        this.setState({
          stores: stores,
          selectedStore: stores[0].node,
          storeInformation: storeInformation,
        });
      }
    }
    console.log(JSON.stringify(storeInformation));
  };

  render() {
    const { spinnerLoading } = this.state;
    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Modal
          size="lg"
          isOpen={this.state.errorModalVisible}
          toggle={this.toggleErrorMessageModal}
        >
          <ErrorMessage
            editable={true}
            errorMessage={this.state.errorMessage}
            goBack={this.toggleErrorMessageModal}
          />
        </Modal>
        <Container fluid style={{ padding: 0, margin: 0 }}>
          <Row noGutters>
            <Col>
              <CardHeader>
                <Container fluid>
                  <Row>
                    <Col
                      xs="12"
                      sm="12"
                      md="4"
                      lg="4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <h5>{"Offers/Discount"}</h5>
                    </Col>
                  </Row>
                </Container>
              </CardHeader>
              <Card style={{ padding: 10, margin: 10 }}>
                <div
                  class="row"
                  style={{
                    margin: 5,
                  }}
                >
                  <p style={{ width: 120 }}>Offer name</p>
                  <Input
                    style={{
                      marginRight: 10,
                      padding: 3,
                      width: 200,
                    }}
                    placeholder="Enter offer name"
                    onChange={(e) => {
                      this.setState({ offerName: e.target.value });
                    }}
                  />
                </div>
                <div
                  class="row"
                  style={{
                    margin: 5,
                  }}
                >
                  <p style={{ width: 120 }}>Offer description</p>
                  <Input
                    style={{
                      marginRight: 10,
                      padding: 3,
                      width: 200,
                    }}
                    placeholder="Enter offer description"
                    onChange={(e) => {
                      this.setState({ offerDescription: e.target.value });
                    }}
                  />
                </div>
              </Card>
              {
                // <Card style={{ padding: 10, margin: 10 }}>
                //   <div onChange={this.onChangeStoreMerchantLevelValue}>
                //     <legend>Store/Merchant Level</legend>
                //     <div
                //       class="row"
                //       style={{
                //         marginLeft: 5,
                //       }}
                //     >
                //       <input
                //         type="radio"
                //         value="STORE"
                //         name="min3"
                //         style={{ marginTop: 6 }}
                //       />
                //       <p style={{ marginLeft: 10 }}>{"STORE"}</p>
                //     </div>
                //     <div
                //       class="row"
                //       style={{
                //         marginLeft: 5,
                //       }}
                //     >
                //       <input
                //         type="radio"
                //         value="MERCHANT"
                //         name="min3"
                //         style={{ marginTop: 6 }}
                //       />
                //       <p style={{ marginLeft: 10 }}>{"MERCHANT"}</p>
                //     </div>
                //   </div>
                // </Card>
              }
              <Card style={{ padding: 0, margin: 10 }}>
                <Row
                  noGutters
                  style={{
                    paddingLeft: 10,
                    paddingRight: 10,
                    paddingTop: 10,
                  }}
                >
                  <p
                    style={{
                      marginRight: 10,
                    }}
                  >
                    {"Discount Code"}
                  </p>
                  <Button
                    color={"primary"}
                    style={{ height: 40 }}
                    onClick={() => {}}
                  >
                    {"Generate Code"}
                  </Button>
                </Row>
                <Row
                  noGutters
                  style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 10 }}
                >
                  <p style={{ marginRight: 10 }}>{"No code required"}</p>

                  {this.state.codeSelect === true ? (
                    <img
                      style={{
                        width: 30,
                        height: 30,

                        objectFit: "contain",
                      }}
                      alt={""}
                      src={require("../../assets/img/select.png")}
                      onClick={() => {
                        this.setState({ codeSelect: !this.state.codeSelect });
                      }}
                    />
                  ) : (
                    <img
                      style={{
                        width: 26,
                        height: 26,
                        marginLeft: 10,
                        objectFit: "contain",
                      }}
                      alt={""}
                      src={require("../../assets/img/unselect.png")}
                      onClick={() => {
                        this.setState({ codeSelect: !this.state.codeSelect });
                      }}
                    />
                  )}
                </Row>
                <Row noGutters style={{ padding: 10 }}>
                  <Input
                    style={{
                      marginRight: 10,
                      padding: 3,
                      width: 200,
                    }}
                    placeholder="Enter Manual Code"
                    onChange={this.handleChangeManualCode}
                  />
                </Row>
                <p style={{ marginLeft: 10 }}>
                  {"Customers will enter this code at checkout"}
                </p>
              </Card>
              <Card style={{ padding: 10, margin: 10 }}>
                <div onChange={this.onChangeMRValue}>
                  <legend>Minimum Requirements</legend>
                  <input type="radio" value="1" name="min" /> Minimum purchase
                  amount
                  <Input
                    type="number"
                    style={{ margin: 10, width: 200 }}
                    onChange={(event) => {
                      this.setState({ purchaseAmount: event.target.value });
                    }}
                  />
                  <input type="radio" value="2" name="min" /> Minimum quantity
                  of amount
                  <Input
                    type="number"
                    style={{ margin: 10, width: 200 }}
                    onChange={(event) => {
                      this.setState({ quantityAmount: event.target.value });
                    }}
                  />
                  <input type="radio" value="3" name="min" /> None
                </div>
              </Card>
              <Card style={{ padding: 10, margin: 10 }}>
                <div onChange={this.onChangeTypes}>
                  <legend>Types</legend>
                  <div
                    class="row"
                    style={{
                      marginLeft: 5,
                    }}
                  >
                    <input
                      type="radio"
                      name="min1"
                      value="BUYXGETY"
                      style={{ marginTop: 6 }}
                    />
                    <p style={{ marginLeft: 6 }}>Buy X and get Y </p>
                  </div>
                  <div class="row" style={{ marginTop:10, marginLeft: 14 }}>
                    <p style={{ marginRight: 10 }}>X:</p>
                    <Button color= "primary" onclick={()=>{this.selectproductX()}}>Select Product ( X )</Button>
                    {/*<Autocomplete
                      getItemValue={(item) => this.getStockName(item)}
                      items={this.state.filterData}
                      renderItem={(item, isHighlighted) => (
                        <div
                          style={{
                            background: isHighlighted ? "lightgray" : "white",
                          }}
                        >
                          {this.getStockName(item)}
                        </div>
                      )}
                      value={this.state.filterValue}
                      onChange={(e) => {
                        this.setState({
                          filterValue: e.target.value,
                          filterData: filterData(
                            this.state.stocks,
                            e.target.value
                          ),
                        });
                      }}
                      onSelect={(val) => {
                        this.setState({ selectedSkuX: val, filterValue: val });
                      }}
                      menuStyle={{
                        borderRadius: "3px",
                        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                        background: "rgba(255, 255, 255, 0.9)",
                        padding: "2px 0",
                        fontSize: "90%",
                        position: "fixed",
                        overflow: "auto",
                        maxHeight: "30%",
                      }}
                    />*/}
                  </div>
                  <div class="row" style={{marginTop:10, marginLeft: 14 }}>
                    <p style={{ marginRight: 10 }}>Y:</p>
                    <Button color= "success" onclick={()=>{this.selectproductY()}}>Select Product ( Y )</Button>
                    {/*<Autocomplete
                      getItemValue={(item) => this.getStockName(item)}
                      items={this.state.filterDataY}
                      renderItem={(item, isHighlighted) => (
                        <div
                          style={{
                            background: isHighlighted ? "lightgray" : "white",
                          }}
                        >
                          {this.getStockName(item)}
                        </div>
                      )}
                      value={this.state.filterValueY}
                      onChange={(e) => {
                        this.setState({
                          filterValueY: e.target.value,
                          filterDataY: filterDataY(
                            this.state.stocks,
                            e.target.value
                          ),
                        });
                      }}
                      onSelect={(val) => {
                        this.setState({ selectedSkuY: val, filterValueY: val });
                      }}
                      menuStyle={{
                        borderRadius: "3px",
                        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                        background: "rgba(255, 255, 255, 0.9)",
                        padding: "2px 0",
                        fontSize: "90%",
                        position: "fixed",
                        overflow: "auto",
                        maxHeight: "30%",
                      }}
                    />*/}
                  </div>
                  <div class="row" style={{ marginLeft: 14 }}>
                    <p style={{ marginTop: 12 }}>Y: Percentage</p>
                    <Input
                      type="number"
                      placeholder={"Enter value"}
                      style={{ margin: 10, width: 200 }}
                      onChange={(event) => {
                        this.setState({ YPercentage: event.target.value });
                      }}
                    />
                  </div>
                  <input type="radio" value="PERCENTAGE" name="min1" />{" "}
                  Percentage
                  <Input
                    type="number"
                    placeholder="Enter percantage"
                    style={{ margin: 10, width: 200 }}
                    onChange={(event) => {
                      this.setState({ percentage: event.target.value });
                    }}
                  />
                  <Input
                    type="number"
                    placeholder="Enter maximum amount"
                    style={{ margin: 10, width: 200 }}
                    onChange={(event) => {
                      this.setState({
                        percentageMaxAmount: event.target.value,
                      });
                    }}
                  />
                  <input type="radio" value="FIXED" name="min1" /> Fixed amount
                  <Input
                    type="number"
                    style={{ margin: 10, width: 200 }}
                    onChange={(event) => {
                      this.setState({ fixedAmount: event.target.value });
                    }}
                  />
                </div>
              </Card>

              <Card style={{ padding: 10, margin: 10 }}>
                <div onChange={this.onChangeUsageLimits}>
                  <legend>Usage Limits</legend>
                  <input type="radio" value="PER_PERSON" name="min2" /> Limit
                  number of times this discount can be used in total
                  <Input
                    type="number"
                    style={{ margin: 10, width: 200 }}
                    onChange={(event) => {
                      this.setState({ usageLimitNumber: event.target.value });
                    }}
                  />
                  <div
                    class="row"
                    style={{
                      marginLeft: 5,
                    }}
                  >
                    <input
                      type="radio"
                      value="TOTAL"
                      name="min2"
                      style={{ marginTop: 6 }}
                    />
                    <p style={{ width: "75%", marginLeft: 6 }}>
                      Limit to one use per customer
                    </p>
                    <Input
                      type="number"
                      style={{ margin: 10, width: 200 }}
                      onChange={(event) => {
                        this.setState({ usagePerCustomer: event.target.value });
                      }}
                    />
                  </div>
                  <div
                    class="row"
                    style={{
                      marginLeft: 5,
                    }}
                  >
                    <input
                      type="radio"
                      value="3"
                      name="NONE"
                      style={{ marginTop: 6 }}
                    />
                    <p style={{ width: "75%", marginLeft: 6 }}>None</p>
                  </div>
                </div>
              </Card>

              <Card style={{ padding: 10, margin: 10 }}>
                <legend>Active Dates</legend>

                <Row style={{ marginTop: 15 }}>
                  <Col xs="12" sm="12" md="4" lg="4">
                    <p> {"Start Date"} </p>
                    <div
                      style={{
                        borderWidth: 1,
                        borderColor: "red",
                        borderRadius: 6,
                        paddingLeft: 2,
                        paddingRight: 2,
                        paddingTop: 2,
                        paddingBottom: 2,
                      }}
                    >
                      <DatePicker
                        customInput={<CustomInput />}
                        style={{}}
                        selected={this.state.startDate}
                        minDate={moment().endOf("day")}
                        onChange={this.handleStartDateChange}
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={1}
                        timeCaption="time"
                        dateFormat="DD/MM/YYYY HH:mm"
                      />
                    </div>
                  </Col>

                  <Col xs="12" sm="12" md="4" lg="4">
                    <div
                      style={{
                        borderWidth: 1,
                        borderColor: "red",
                        borderRadius: 6,
                        paddingLeft: 2,
                        paddingRight: 2,
                        paddingTop: 2,
                        paddingBottom: 2,
                      }}
                    >
                      <p>{"End Date"} </p>
                      {this.state.endDateSelect === true ? (
                        <img
                          style={{
                            width: 30,
                            height: 30,
                            marginRight: 10,
                            objectFit: "contain",
                          }}
                          alt={""}
                          src={require("../../assets/img/select.png")}
                          onClick={() => {
                            this.setState({
                              endDateSelect: !this.state.endDateSelect,
                            });
                          }}
                        />
                      ) : (
                        <img
                          style={{
                            width: 26,
                            height: 26,
                            marginLeft: 10,
                            marginRight: 10,
                            objectFit: "contain",
                          }}
                          alt={""}
                          src={require("../../assets/img/unselect.png")}
                          onClick={() => {
                            this.setState({
                              endDateSelect: !this.state.endDateSelect,
                            });
                          }}
                        />
                      )}

                      <DatePicker
                        customInput={<CustomInput />}
                        selected={this.state.endDate}
                        showTimeSelect
                        timeFormat="HH:mm"
                        dateFormat="DD/MM/YYYY HH:mm"
                        timeIntervals={1}
                        timeCaption="time"
                        minDate={moment().endOf("day")}
                        onChange={this.handleEndDateChange}
                      />
                    </div>
                  </Col>
                </Row>
              </Card>
              <Card style={{ padding: 10, margin: 10 }}>
                <Row className="justify-content-center">
                  <Button
                    color={"primary"}
                    style={{}}
                    onClick={() => {
                      this.setMerchantOffers();
                    }}
                  >
                    {"Submit"}
                  </Button>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
      </LoadingOverlay>
    );
  }

  getStockName = (stock) => {
    let name = "";
    if (stock.node.sku.quantity === null) {
      name =
        stock.node.sku.product.category.name + " - " + stock.node.referenceName;
    } else {
      name =
        stock.node.sku.product.category.name +
        " - " +
        stock.node.referenceName +
        " - " +
        stock.node.sku.quantity;
    }

    return name;
  };
  handleStartDateChange = (date) => {
    // this.state.startDate.format("YYYY-MM-DDT")
    console.log("date", date.format("YYYY-MM-DD"));
    console.log("time", date.format("HH:mm"));

    this.setState({
      startDate: date,
    });
  };

  // date = this.state.startDate.format("YYYY-MM-DDTHH:mm");
  // date = date + ":00+00:00";
  // endD = this.state.endDate.format("YYYY-MM-DDTHH:mm");
  //       // endD = endD + "23:59:59+00:00";
  //       endD = endD + ":59+00:00";

  handleEndDateChange = (date) => {
    if (
      Date.parse(this.state.startDate.format("MM/DD/YYYY")) >=
      Date.parse(date.format("MM/DD/YYYY"))
    ) {
      if (
        Date.parse(this.state.startDate.format("MM/DD/YYYY")) ===
        Date.parse(date.format("MM/DD/YYYY"))
      ) {
        this.setState({
          endDate: date,
        });
      } else {
        alert("End date should be greater than Start date");
      }
    } else {
      this.setState({
        endDate: date,
      });
    }
  };
  onChangeStoreMerchantLevelValue = (event) => {
    console.log(event.target.value);
    this.setState({ storeMerchantLevel: event.target.value + "" });
  };
  onChangeMRValue = (event) => {
    console.log(event.target.value);
    this.setState({ MRValue: event.target.value + "" });
  };

  onChangeTypes = (event) => {
    console.log(event.target.value);
    this.setState({ types: event.target.value + "" });
  };
  onChangeUsageLimits = (event) => {
    console.log(event.target.value);
    this.setState({ usageLimits: event.target.value + "" });
  };
  handleChangeManualCode = (event) => {
    this.setState({ manualCode: event.target.value });
  };
  getInventory = async () => {
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();

    let response = await requestManager.getResponseFromPredefinedQuery(
      "getInventory",
      {
        storeId: this.state.selectedStore && this.state.selectedStore.id,
        referenceName_Icontains: "",
      }
    );
    console.log("getInventory", JSON.stringify(response));
    if (response.error === null) {
      this.setState((prevState) => ({
        stocks: response.data.stocks.edges,
        spinnerLoading: false,
        filterData: filterData(
          response.data.stocks.edges,
          prevState.filterValue
        ),
        filterDataY: filterData(
          response.data.stocks.edges,
          prevState.filterValueY
        ),
      }));
    } else {
      this.setState({ spinnerLoading: false });
      alert(
        "Unable to update inventory. Please check your internet connection."
      );
    }
  };

  setMerchantOffers = async () => {
    console.log("types", this.state.types);
    // if (this.state.offerName.length < 2) {
    //   this.toggleErrorMessageModal("Enter valid offer name");
    //   return;
    // }

    // if (this.state.codeSelect === false) {
    //   this.toggleErrorMessageModal("Enter code");
    //   return;
    // } else if (this.state.manualCode.length < 2) {
    //   this.toggleErrorMessageModal("Enter valid code");
    //   return;
    // }
    // let quantityAmount = -1,
    //   purchaseAmount = -1;
    // if (this.state.MRValue === "0") {
    //   this.toggleErrorMessageModal("Select Minimum Requriements");
    //   return;
    // } else if (this.state.MRValue === "1") {
    //   if (
    //     this.state.purchaseAmount === "" ||
    //     // eslint-disable-next-line
    //     parseInt(this.state.purchaseAmount) === 0
    //   ) {
    //     this.toggleErrorMessageModal("Enter valid amount");
    //     return;
    //   }
    //   purchaseAmount = this.state.purchaseAmount;
    // } else if (this.state.MRValue === "2") {
    //   if (
    //     this.state.quantityAmount === "" ||
    //     // eslint-disable-next-line
    //     parseInt(this.state.quantityAmount) === 0
    //   ) {
    //     this.toggleErrorMessageModal("Enter valid amount");
    //     return;
    //   }
    //   quantityAmount = this.state.quantityAmount;
    // }

    // let stockXId = "",
    //   stockYId = "",
    //   YPercentage = -1;
    // if (this.state.types === "0") {
    //   this.toggleErrorMessageModal("Select types");
    //   return;
    // } else if (this.state.types === "BUYXGETY") {
    //   if (this.state.selectedSkuX === "" || this.state.selectedSkuY === "") {
    //     this.toggleErrorMessageModal("Enter valid stock");
    //     return;
    //   } else {
    //     let stocks = this.state.stocks;

    //     for (let i = 0; i < stocks.length; i++) {
    //       let stockName = this.getStockName(stocks[i]);

    //       if (stockName === this.state.selectedSkuX) {
    //         stockXId = stocks[i].node.id;
    //       }
    //       if (stockName === this.state.selectedSkuY) {
    //         stockYId = stocks[i].node.id;
    //       }
    //     }
    //     if (this.state.stockXId === "" || this.state.stockYId === "") {
    //       this.toggleErrorMessageModal("Enter valid stock");
    //       return;
    //     }
    //     if (
    //       this.state.YPercentage === "" ||
    //       // eslint-disable-next-line
    //       parseInt(this.state.YPercentage) > 100
    //     ) {
    //       this.toggleErrorMessageModal("Enter valid Y percantage");
    //       return;
    //     } else {
    //       YPercentage = this.state.YPercentage;
    //     }
    //   }
    // }
    // let percentageMaxAmount = -1,
    //   fixedAmount = -1;
    // if (this.state.types === "PERCENTAGE") {
    //   if (this.state.percentageMaxAmount === "") {
    //     this.toggleErrorMessageModal("Enter percentage max value");
    //   }
    //   percentageMaxAmount = this.state.percentageMaxAmount;
    // } else if (this.state.types === "FIXED") {
    //   if (this.state.fixedAmount === "") {
    //     this.toggleErrorMessageModal("Enter fixed amount");
    //   }
    //   fixedAmount = this.state.fixedAmount;
    // }
    // let usageLimitValue = -1,
    //   usageLimits = this.state.usageLimits;
    // if (this.state.usageLimits === "0") {
    //   this.toggleErrorMessageModal("Select usage limits");
    //   return;
    // }

    // if (this.state.usageLimits === "TOTAL") {
    //   // eslint-disable-next-line
    //   if (parseInt(this.state.usageLimitNumber) === 0) {
    //     this.toggleErrorMessageModal("Enter usagelimt value");
    //     return;
    //   }
    //   usageLimitValue = parseInt(this.state.usageLimitNumber);
    // }

    // if (this.state.usageLimits === "PER_PERSON") {
    //   // eslint-disable-next-line
    //   if (parseInt(this.state.usagePerCustomer) < 0) {
    //     this.toggleErrorMessageModal("Enter usagelimt value");
    //     return;
    //   }
    //   usageLimitValue = parseInt(this.state.usagePerCustomer);
    // }

    // if (this.state.usageLimits === "NONE") {
    //   // eslint-disable-next-line
    //   usageLimits = "PER_PERSON";
    // }

    // let startDate = this.state.startDate.format("YYYY-MM-DD");
    // let startTime = this.state.startDate.format("HH:mm:ss");

    // let endDate = "2099-12-30",
    //   endTime = "11:59:00";
    // if (this.state.endDateSelect === true) {
    //   endDate = this.state.endDate.format("YYYY-MM-DD");
    //   endTime = this.state.endDate.format("HH:mm:ss");
    // }

    // console.log("date", startDate);
    // console.log("time", startTime);

    this.setState({ spinnerLoading: true });

    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Token " + authToken);
    // actual value
    // JSON.stringify({
    //   n_store_merchant_level: "STORE",
    //   n_store_merchant_id: this.state.selectedStore.id,
    //   n_offer_name: this.state.offerName,
    //   n_offer_description: this.state.offerDescription,
    //   n_discount_code: this.state.manualCode,
    //   n_type: this.state.types,
    //   n_max_limit: this.state.percentageMaxAmount,
    //   n_value: this.state.fixedAmount,
    //   n_x_sku_id: stockXId,
    //   n_y_sku_id: stockYId,
    //   n_y_sku_id_percentage_discount: YPercentage,
    //   minimum_requirement_card_item: purchaseAmount,
    //   minimum_requirement_quantity: quantityAmount,
    //   n_usage_limit_type: usageLimits,
    //   n_usage_limit: usageLimitValue,
    //   n_start_date: startDate,
    //   n_start_time: startTime,
    //   n_end_date: endDate,
    //   n_end_time: endTime,
    // })

    // hard coded value
    // stock id  "U3RvY2s6MDRjY2Y5ZDYtYzgxOS00YWI3LThkYmUtMWIzZWU0Mjk5ZGUy",
    // JSON.stringify({
    //   n_store_merchant_level: "STORE",
    //   n_store_merchant_id: this.state.selectedStore.id,
    //   n_offer_name: "August 15",
    //   n_offer_description: "August",
    //   n_discount_code: "KFC123",
    //   n_type: "PERCENTAGE",
    //   n_max_limit: 100,
    //   n_value: 10,
    //   n_x_sku_id: "",
    //   n_y_sku_id: "",
    //   n_y_sku_id_percentage_discount: -1,
    //   minimum_requirement_card_item: -1,
    //   minimum_requirement_quantity: -1,
    //   n_usage_limit_type: "PER_PERSON",
    //   n_usage_limit: 1,
    //   n_start_date: "2020-07-15",
    //   n_start_time: "00:00:00",
    //   n_end_date: "2099-12-30",
    //   n_end_time: "11:59:00",
    // })
    try {
      var vtimestamp = generateEpochTimestamp();      
      let response = await fetch(
        config.getHost() + "/product/set_merchant_offer/",
        {
          method: "POST",
          headers: {
            Authorization: `Token ${authToken}`,
            "Content-Type": "application/json",
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, authToken)                 
          },
          body: JSON.stringify({
            n_store_merchant_level: "STORE",
            n_store_merchant_id: this.state.selectedStore.id,
            n_offer_name: "August 15 Fixed",
            n_offer_description: "August",
            n_discount_code: "KFC123",
            n_type: "BUYXGETY",
            n_max_limit: -1,
            n_value: 100,
            n_x_sku_id:
              "U0tVOjU4NTkzOTBiLWE2N2EtNDA0OC05ZDkzLWJkNTQwYWFlZTk0Zg==",
            n_y_sku_id:
              "U0tVOjU4NTkzOTBiLWE2N2EtNDA0OC05ZDkzLWJkNTQwYWFlZTk0Zg==",
            n_y_sku_id_percentage_discount: 20,
            minimum_requirement_card_item: -1,
            minimum_requirement_quantity: -1,
            n_usage_limit_type: "PER_PERSON",
            n_usage_limit: 1,
            n_start_date: "2020-07-20",
            n_start_time: "00:00:00",
            n_end_date: "2099-12-30",
            n_end_time: "11:59:00",
          }),
        }
      );

      console.log("Response", response);

      if (response.status === 200) {
        this.setState({
          spinnerLoading: false,
        });
      } else {
        this.setState({
          spinnerLoading: false,
        });
      }
    } catch (error) {
      console.log("error", error);
      this.setState({
        spinnerLoading: false,
      });
    }
  };

  getMinReq = (value) => {
    //FIXED, PERCENTAGE, BUYXGETY
    switch (value) {
      case "1":
        return "";
      case "2":
        return "PERCENTAGE";
      case "3":
        return "FIXED";
      default:
        return -1;
    }
  };
}



// WEBPACK FOOTER //
// ./src/pages/Offers/Offers.js